/** @jsxImportSource @emotion/react */
import { Box, Divider, Stack } from '@mui/material';
import React, { ReactElement } from 'react';
import AppHeader from 'src/components/AppHeader/AppHeader';
import { DEFAULT_SPACING } from 'src/theme/style-consts';

export function TwoColumnPageBase(props: {leftContent: ReactElement, pageContent: ReactElement, fullscreen?: boolean}) {

  return (
      <>
        <Box hidden={props.fullscreen}>
          <AppHeader/>
        </Box>
        <Stack
            direction='row'
            divider={<Divider orientation="vertical" flexItem hidden={props.fullscreen}/>}
            sx={{height: props.fullscreen ? '100vh' : `calc(100vh - 64px)`, overflow: 'hidden'}}>
          <Box
              hidden={props.fullscreen}
              sx={{flexGrow: 0, flexShrink: 0, width: '400px', overflow: 'auto', padding: DEFAULT_SPACING}}
          >
            {props.leftContent}
          </Box>

          <Box sx={{flexGrow: 1, overflow: 'auto', padding: DEFAULT_SPACING}}>
            {props.pageContent}
          </Box>
        </Stack>
      </>
  )
}